import {Button, Grid, Paper, TextField, Typography, LinearProgress, Box, Checkbox, Table, TableBody, TableRow, TableCell} from "@mui/material";
import axios from "axios";
import * as React from "react";
import {Config} from "../../config/config";
import {Helpers} from "../../utils/helpers";
import {PopupMessage} from "../../utils/message";
import {LoadingIndicator} from "../../components/LoadingIndicator";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const marginLeftStyle = {marginLeft: '10%'};
const borderStyle = {border: '1px solid #e0e0e0', padding: '10px'};
const buttonStyle = {marginLeft: '10px'};

export class InactiveCacheV2 extends React.Component<any, any> {
    pollInterval: any;
    constructor(props: any) {
        super(props);

        this.state = {
            loading: false,
            temporaryTable: {
                exists: false,
                rows: 0,
            },
            readRedisKey: {
                cursor: 0,
                limit: 50000,
                progress: {
                    taskId: '',
                    status: 'idle',
                    message: '',
                    crawlAmount: 0,
                    userIds: [],
                    interval: 1000,
                    startTime: null,
                    endTime: null,
                    cursor: 0,
                }
            },
            processTemporaryTable: {
                inactive: 0,
                ghost: 0,
                offset: 0,
                limit: 1000,
                daysSinceLastLogin: 30
            }
        }

        this.pollInterval = null;
    }

    async componentDidMount() {
        await this.fetchData();
    }

    componentWillUnmount() {
        if (this.pollInterval) {
            clearInterval(this.pollInterval);
        }
    }

    onLoading() {
        this.setState({loading: true});
    }

    onLoaded() {
        this.setState({loading: false});
    }

    async fetchData() {
        const url = `${Config.getInstance.apiUrl}/api/inactive-user/temporary-table`;
        const headers = {
            Authorization: Helpers.getSessionId(),
        }

        this.onLoading();

        const response = await axios.get(url, {headers});
        const data = response.data;
        const success = data.success;
        if (success) {
            const exists = data.exists;
            const rows = data.rows;
            this.setState({loading: false, temporaryTable: {exists, rows}});
        } else {
            PopupMessage.error("Failed to fetch data")
        }

        this.onLoaded();
    }

    async createTemporaryTable() {
        this.onLoading();

        const url = `${Config.getInstance.apiUrl}/api/inactive-user/create-temporary-table`;
        const headers = {
            Authorization: Helpers.getSessionId(),
        }
        const response = await axios.post(url, {}, {headers});
        const data = response.data;
        const success = data.success;
        if (success) {
            this.fetchData();
            PopupMessage.success("Temporary table created")
        } else {
            PopupMessage.error("Failed to create temporary table")
        }

        this.onLoaded();

        return success;
    }

    async insertTemporaryTable() {
        this.onLoading();
        const url = `${Config.getInstance.apiUrl}/api/inactive-user/insert-temporary-table`;
        const headers = {
            Authorization: Helpers.getSessionId(),
        }
        const body = {
        }
        const response = await axios.post(url, body, {headers});
        const data = response.data;
        const success = data.success;
        if (success) {
            const userIds = data.userIds;
            this.setState({readRedisKey: {...this.state.readRedisKey, insertedUserIds: userIds}});
            this.fetchData();
            PopupMessage.success("Temporary table inserted")
        } else {
            PopupMessage.error("Failed to insert temporary table")
        }

        this.onLoaded();

        return success;
    }

    async startCrawlRedisKeysTask() {
        this.onLoading();
        const url = `${Config.getInstance.apiUrl}/api/inactive-user/start_crawl_redis_keys_task`;
        const headers = {
            Authorization: Helpers.getSessionId(),
        }
        const body = {
            cursor: this.state.readRedisKey.cursor,
            limit: this.state.readRedisKey.limit,
        }
        const response = await axios.post(url, body, {headers});
        const data = response.data;
        const success = data.success;
        const progress = this.state.readRedisKey.progress;
        if (success) {
            console.log(`start crawl redis keys task response ${JSON.stringify(data)}`)
            const taskId = data.taskId;
            const message = data.message;
            const cursor = data.cursor;

            progress.taskId = taskId;
            progress.status = 'started';
            progress.message = message;
            progress.startTime = new Date();
            progress.cursor = cursor;
            progress.crawlAmount = 0;
            progress.endTime = null;
            progress.userIds = [];

            this.setState({readRedisKey: {...this.state.readRedisKey, progress: progress}});
            this.fetchData();
            PopupMessage.success("Crawl redis keys task started")
            this.listenToCleanupProgress(data.taskId);
        } else {
            PopupMessage.error("Failed to start crawl redis keys task")
        }

        this.onLoaded();
    }

    async getCrawlRedisKeysTaskStatus() {
        const taskId = this.state.readRedisKey.progress.taskId;
        const url = `${Config.getInstance.apiUrl}/api/inactive-user/crawl_redis_keys_status/${taskId}`;
        const headers = {
            Authorization: Helpers.getSessionId(),
        }
        const response = await axios.get(url, {headers});
        const data = response.data;
        const success = data.success;

        if (success) {
            const status = data.status;
            const message = data.message;
            const userIds = data.userIds;
            this.setState({readRedisKey: {...this.state.readRedisKey, progress: {taskId, status, message, userIds}}});
        } else {
            PopupMessage.error("Failed to get crawl redis keys task status")
        }
    }

    async listenToCleanupProgress(taskId: string) {
        // Use polling method directly (more reliable)
        this.pollCrawlRedisKeysTaskProgress(taskId);
    }

    async pollCrawlRedisKeysTaskProgress(taskId: string) {
        this.pollInterval = setInterval(async () => {
            const url = `${Config.getInstance.apiUrl}/api/inactive-user/crawl_redis_keys_progress/${taskId}`;
            const headers = {
                Authorization: Helpers.getSessionId(),
            }
            const response = await axios.get(url, {headers});
            const data = response.data;
            const success = data.success;

            const progress = this.state.readRedisKey.progress;

            if (success) {
                console.log(`crawl redis keys task progress response ${JSON.stringify(data)}`)
                const status = data.status;
                const message = data.message;
                const crawlAmount = data.crawlAmount;
                const cursor = data.cursor;
                progress.status = status;
                progress.message = message;
                progress.crawlAmount = crawlAmount;
                progress.cursor = cursor;
                this.setState({readRedisKey: {...this.state.readRedisKey, progress: progress}});

                if (status === 'completed') {
                    // set status to idle
                    // progress.status = 'idle';
                    //progress.message = '';
                    //progress.crawlAmount = 0;
                    progress.endTime = new Date();
                    this.setState({readRedisKey: {...this.state.readRedisKey, progress: progress}});
                    PopupMessage.success("Crawl redis keys task completed")
                    clearInterval(this.pollInterval);
                } else if (status === 'error') {
                    // set status to idle
                    progress.status = 'idle';
                    progress.message = '';
                    progress.crawlAmount = 0;
                    progress.endTime = new Date();
                    this.setState({readRedisKey: {...this.state.readRedisKey, progress: progress}});
                    PopupMessage.error("Crawl redis keys task failed")
                    clearInterval(this.pollInterval);
                }
            } else {
                PopupMessage.error("Failed to get crawl redis keys task progress")
            }
        }, 1000);
    }

    async deleteTemporaryTable() {
        const url = `${Config.getInstance.apiUrl}/api/inactive-user/delete-temporary-table`;
        const headers = {
            Authorization: Helpers.getSessionId(),
        }
        const response = await axios.delete(url, {headers});
        const data = response.data;
        const success = data.success;
        if (success) {
            PopupMessage.success("Temporary table deleted");
            await this.fetchData();
        } else {
            PopupMessage.error("Failed to delete temporary table")
        }
    }

    async processTemporaryTable() {
        const url = `${Config.getInstance.apiUrl}/api/inactive-user/process-temporary-table`;
        const headers = {
            Authorization: Helpers.getSessionId(),
        }
        const body = {
            offset: this.state.processTemporaryTable.offset,
            limit: this.state.processTemporaryTable.limit,
            daysSinceLastLogin: this.state.processTemporaryTable.daysSinceLastLogin
        }
        const response = await axios.post(url, body, {headers});
        const data = response.data;
        const success = data.success;
        if (success) {
            const deletedCount = data.deletedCount;
            PopupMessage.success(`Temporary table processed ${deletedCount} keys`)

            await this.getFormattedTemporaryTable();
        } else {
            PopupMessage.error("Failed to process temporary table")
        }
        return success;
    }

    async getFormattedTemporaryTable() {
        const url = `${Config.getInstance.apiUrl}/api/inactive-user/get-formatted-temporary-table`;
        const headers = {
            Authorization: Helpers.getSessionId(),
        }

        const params = {
            daysSinceLastLogin: this.state.processTemporaryTable.daysSinceLastLogin
        }
        const response = await axios.get(url, {headers, params});
        const data = response.data;
        const success = data.success;
        if (success) {
            const inactive = data.inactive;
            const ghost = data.ghost;
            this.setState({processTemporaryTable: {...this.state.processTemporaryTable, inactive, ghost}});
        } else {
            PopupMessage.error("Failed to get formatted temporary table")
        }
    }

    async putIntoClipboard(text: string) {
        await navigator.clipboard.writeText(text);
    }

    async putIntoClipboardList(list: string[]) {
        try {
            const text = list.join('\n');
            await this.putIntoClipboard(text);
            PopupMessage.success(`Copied to clipboard`);
        }
        catch (e) {
            PopupMessage.error("Failed to copy to clipboard")
            console.error(e);
        }
    }

    renderStep1() {
        return (
            <Grid container sm={12} style={borderStyle}>
                <Grid item container sm={12}>
                    <Grid item sm={6}>
                        <Typography variant="h6" gutterBottom>
                            Step 1: Create temporary table
                        </Typography>
                        <Typography variant="body1" style={marginLeftStyle}>
                            Table exists:&nbsp;
                            <span
                                style={{
                                    color: this.state.temporaryTable.exists ? "green" : "red",
                                    fontWeight: 600,
                                }}
                            >
                                {this.state.temporaryTable.exists ? "YES ✓" : "NO ✗"}
                            </span>
                        </Typography>
                        <Typography variant="body1" style={marginLeftStyle}>
                            Table rows: {this.state.temporaryTable.rows}
                        </Typography>
                    </Grid>
                    <Grid item sm={6} style={{textAlign: 'right'}}>
                        <Button
                            disabled={this.state.loading || this.state.temporaryTable.exists}
                            variant="contained"
                            color="primary"
                            onClick={() => this.createTemporaryTable()}
                        >
                            Create
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        )
    }

    renderCrawlRedisKeysTaskProgress() {

        const {progress} = this.state.readRedisKey;
        if (progress.status === 'idle' && progress.message === '') {
            return null;
        }

        const startTime = progress.startTime;
        const endTime = progress.endTime || new Date();
        const duration = endTime.getTime() - startTime.getTime();
        const durationInSeconds = duration / 1000;

        return (
            < Grid container sm={12}>
                <Grid item container sm={12}>
                    <Typography variant="h6" gutterBottom>
                        {`${progress.message} - `}
                        {`Crawl ${progress.crawlAmount} user ids in ${durationInSeconds} seconds - Cursor ${progress.cursor}`}
                    </Typography>
                </Grid>
            </Grid>
        )
    }

    renderStep2() {

        return (
            <Grid container sm={12} style={borderStyle}>
                <Grid item container sm={12}>
                    <Grid item sm={6}>
                        <Typography variant="h6" gutterBottom>
                            {"Step 2: Crawl Redis Keys and Insert into Temporary Table"}
                        </Typography>
                        <Typography variant="h6">


                        </Typography>
                    </Grid>
                    <Grid item container sm={6} justifyContent={"flex-end"}>
                        <TextField
                            label="Cursor"
                            value={this.state.readRedisKey.cursor}
                            onChange={(e) => this.setState({readRedisKey: {...this.state.readRedisKey, cursor: e.target.value}})}
                        />
                        <TextField
                            label="Limit"
                            value={this.state.readRedisKey.limit}
                            onChange={(e) => this.setState({readRedisKey: {...this.state.readRedisKey, limit: e.target.value}})}
                        />
                        <Button
                            disabled={this.state.loading || (this.state.readRedisKey.progress.status !== 'idle' && this.state.readRedisKey.progress.status !== 'completed')}
                            style={buttonStyle}
                            variant="contained"
                            color="primary"
                            onClick={() => this.startCrawlRedisKeysTask()}
                        >
                            Insert Keys
                        </Button>
                    </Grid>
                </Grid>
                <Grid item container sm={12}>
                    {this.renderCrawlRedisKeysTaskProgress()}
                </Grid>
            </Grid>
        )
    }

    renderStep3() {
        return (
            <Grid container sm={12} style={borderStyle}>
                <Grid item container sm={12}>
                    <Grid item sm={6}>
                        <Typography variant="h6" gutterBottom>
                            Step 3: Process Temporary Table
                        </Typography>

                    </Grid>
                </Grid>
                <Grid item container sm={12} alignItems="flex-start">
                    <Grid item sm={6}>
                        <Typography style={marginLeftStyle} variant="h6" gutterBottom>Inactive: {this.state.processTemporaryTable.inactive}</Typography>
                        <Typography style={marginLeftStyle} variant="h6" gutterBottom>Ghost: {this.state.processTemporaryTable.ghost}</Typography>
                        <TextField
                            style={marginLeftStyle}
                            label="Days since last login"
                            value={this.state.processTemporaryTable.daysSinceLastLogin}
                            onChange={(e) => this.setState({processTemporaryTable: {...this.state.processTemporaryTable, daysSinceLastLogin: e.target.value}})}
                        />
                        <Button
                            disabled={this.state.loading}
                            variant="contained"
                            color="primary"
                            onClick={() => this.getFormattedTemporaryTable()}
                        >
                            Get Data
                        </Button>
                    </Grid>

                    <Grid item container sm={6} justifyContent="flex-end" alignItems="center">
                        <TextField
                            label="Offset"
                            value={this.state.processTemporaryTable.offset}
                            onChange={(e) => this.setState({processTemporaryTable: {...this.state.processTemporaryTable, offset: e.target.value}})}
                        />
                        <TextField
                            label="Limit"
                            value={this.state.processTemporaryTable.limit}
                            onChange={(e) => this.setState({processTemporaryTable: {...this.state.processTemporaryTable, limit: e.target.value}})}
                        />
                        <Button
                            disabled={this.state.loading}
                            variant="contained"
                            color="warning"
                            onClick={() => this.processTemporaryTable()}
                        >
                            Process
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        )
    }

    renderStep4() {
        return (
            <Grid container sm={12} style={borderStyle}>
                <Grid item container sm={12} justifyContent={"flex-end"}>
                    <Grid item sm={6}>
                        <Typography variant="h6" gutterBottom>
                            Step 4: Delete Temporary Table
                        </Typography>

                    </Grid>
                    <Grid item container sm={6} justifyContent={"flex-end"}>
                        <Button
                            variant="contained"
                            color="error"
                            onClick={() => this.deleteTemporaryTable()}
                        >
                            Delete
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        )
    }

    renderContent() {

        const isTableExists = this.state.temporaryTable.exists;

        // Table with border and padding
        return (
            <Grid container style={{border: '1px solid #e0e0e0', padding: '10px'}}>
                <Grid item container sm={12}>
                    {this.renderStep1()}
                    {isTableExists && this.renderStep2()}

                    {isTableExists && this.renderStep3()}

                    {isTableExists && this.renderStep4()}
                </Grid>
            </Grid>
        )
    }

    render() {
        const progressStatus = this.state.readRedisKey.progress.status;
        const loading = this.state.loading;
        console.log(`progressStatus ${progressStatus}, loading ${loading}`)

        return (
            <div className="contentPadding" style={{width: "100%"}}>
                <div>
                    <Paper className="root" elevation={0}>
                        <Typography variant="h4" style={{marginBottom: '50px'}}>
                            Unactive Cache Cleanup
                        </Typography>

                        {this.renderContent()}

                        {this.state.loading && <LoadingIndicator loadingTextPlaceholder="Fetching data" loadingText={true} />}
                    </Paper>
                </div>
            </div>
        );
    }
}